// SYNC TO specTeam.Shop!
export enum PaymentPresets
{
    Unset = "Unset",
    AllWithCash = "AllWithCash", // 💰+💰
    CashAtDelivery = "CashAtDelivery", // Only for sale, not for rent
    AllWithBankTransfer = "AllWithBankTransfer", // 💳+💳
    AllWithCrypto = "AllWithCrypto", // 🪙+🪙
    DepositWithBankTransfer_ServiceWithCash = "DepositPrepaidServicePostpaid", // 💳+💰
    DepositWithBlik_ServiceWithCash = "DepositPrepaidWithBlikServicePostpaid", // ☎️+💰
    // PartialDepositWithBankTransfer_ServiceWithCash = "PartialDepositPrepaidServicePostpaid",
    // FromPreviousOrder = "FromPreviousOrder",
    // CashAtDelivery = "CashAtDelivery"
}

export const PaymentPresetsValueToLabel = {
    [PaymentPresets.AllWithCash]: "Gotówka (cała opłata przy odbiorze)",
    [PaymentPresets.DepositWithBankTransfer_ServiceWithCash]: "Przedpłata kaucji przelewem, reszta gotówką przy odbiorze",
    [PaymentPresets.DepositWithBlik_ServiceWithCash]: "Przedpłata kaucji Blikiem, reszta gotówką przy odbiorze",
    [PaymentPresets.AllWithBankTransfer]: "Przelew (całość z góry)",
    [PaymentPresets.AllWithCrypto]: "Bitcoin (całość z góry, % zniżki)",
    [PaymentPresets.CashAtDelivery]: "Pobranie",
}
export const BasketPaymentValueToLabel = {
    [PaymentPresets.AllWithCash]: "Gotówka",
    [PaymentPresets.DepositWithBankTransfer_ServiceWithCash]: "Gotówka przy odbiorze",
    [PaymentPresets.DepositWithBlik_ServiceWithCash]: "Gotówka przy odbiorze",
    [PaymentPresets.AllWithBankTransfer]: "Przelew",
    [PaymentPresets.AllWithCrypto]: "Bitcoin",
    [PaymentPresets.CashAtDelivery]: "Pobranie (płatne u kuriera)",
}